import {
    GETHOSPITAL,
    CREATEHOSPITAL,
    UPDATEHOSPITAL,
    GETHOSPITALBYID,
    CREATENOTIFICATION,
    GETNOTIFICATION,
    UPDATENOTIFICATION,
    GETSMS1,
    UPDATESMS1,
    CREATEEMAIL,
    GETEMAIL,
    UPDATEEMAIL,
    DELETEEMAIL,
    GETSMS2,
    UPDATESMS2,
    GETSMS3,
    UPDATESMS3,
    GETSMS4,
    UPDATESMS4,
    GETSMS5,
    UPDATESMS5,
    GETSMS6,
    UPDATESMS6,
    GETSMS7,
    UPDATESMS7,
    DELETESMS1,
    DELETESMS2,
    DELETESMS3,
    DELETESMS4,
    DELETESMS5,
    DELETESMS6,
    DELETESMS7,
    GETPAYMENT1,
    UPDATEPAYMENT1,
    GETPAYMENT2,
    UPDATEPAYMENT2,
    GETPAYMENT3,
    UPDATEPAYMENT3,
    GETPAYMENT4,
    UPDATEPAYMENT4,
    GETPAYMENT5,
    UPDATEPAYMENT5,
    GETPAYMENT6,
    UPDATEPAYMENT6,
    GETPAYMENT7,
    UPDATEPAYMENT7,
    GETPAYMENT8,
    UPDATEPAYMENT8,
    GETPAYMENT9,
    UPDATEPAYMENT9,
    GETPAYMENT10,
    UPDATEPAYMENT10,
    GETPAYMENT11,
    UPDATEPAYMENT11,
    GETPAYMENT12,
    UPDATEPAYMENT12,
    GETPAYMENT13,
    UPDATEPAYMENT13,
    GETPAYMENT14,
    UPDATEPAYMENT14,
    GETPAYMENT15,
    UPDATEPAYMENT15,
    GETPAYMENT16,
    UPDATEPAYMENT16,
    DELETEPAYMENT1,
    DELETEPAYMENT2,
    DELETEPAYMENT3,
    DELETEPAYMENT4,
    DELETEPAYMENT5,
    DELETEPAYMENT6,
    DELETEPAYMENT7,
    DELETEPAYMENT8,
    DELETEPAYMENT9,
    DELETEPAYMENT10,
    DELETEPAYMENT11,
    DELETEPAYMENT12,
    DELETEPAYMENT13,
    DELETEPAYMENT14,
    DELETEPAYMENT15,
    DELETEPAYMENT16,
    CREATESMS1,
    CREATESMS2,
    CREATESMS3,
    CREATESMS4,
    CREATESMS5,
    CREATESMS6,
    CREATESMS7,
    CREATEPAYMENT1,
    CREATEPAYMENT2,
    CREATEPAYMENT3,
    CREATEPAYMENT4,
    CREATEPAYMENT5,
    CREATEPAYMENT6,
    CREATEPAYMENT7,
    CREATEPAYMENT8,
    CREATEPAYMENT9,
    CREATEPAYMENT10,
    CREATEPAYMENT11,
    CREATEPAYMENT12,
    CREATEPAYMENT13,
    CREATEPAYMENT14,
    CREATEPAYMENT15,
    CREATEPAYMENT16,
    CREATEPREFIX,
    GETPREFIX,
    UPDATEPREFIX,
    DELETEPREFIX,
    CREATEROLE,
    GETROLE,
    UPDATEROLE,
    DELETEROLE,
    CREATEBACKUP,
    GETBACKUP,
    UPDATEBACKUP,
    DELETEBACKUP,
    GETLANGUAGE,
    CREATELANGUAGE,
    UPDATELANGUAGE,
    DELETELANGUAGE,
    GETPATIENT,
    CREATEPATIENT,
    UPDATEPATIENT,
    DELETEPATIENT,
    GETSTAFF,
    CREATESTAFF,
    UPDATESTAFF,
    DELETESTAFF,
    GETCAPTCHA,
    CREATECAPTCHA,
    UPDATECAPTCHA,
    DELETECAPTCHA,
    GETMODULE,
    CREATEMODULE,
    UPDATEMODULE,
    DELETEMODULE,
    DELETENOTIFICATION,
    GETMODULEADMIN,
    GETALLMODULE,
    CREATECHILDRENMODULE,
    GETCHILDRENMODULE,
    GETCHILDRENMODULEADMIN,
    UPDATECHILDRENMODULE,
    DELETECHILDRENMODULE,
    GETALLCHILDRENMODULE,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATENOTIFICATION:
            return {
                ...state,
                notificationSaveStatus: action.payload.success,
            }
        case GETNOTIFICATION:
            return {
                ...state,
                notificationList: action.payload.data,
            }
        case UPDATENOTIFICATION:
            return {
                ...state,
                notificationUpdateStatus: action.payload.success,
            }
        case DELETENOTIFICATION:
                return {
                         ...state,
                         notificationDeleteStatus: action.payload.success,
                      }    
        case GETHOSPITAL:
            return {
                ...state,
                hospitalList: action.payload.data,
                hospitalCount: action.payload.data.length
            }
        case GETHOSPITALBYID:

            return {
                ...state,
                hospitalByID: action.payload.data,
            }
        case CREATEHOSPITAL:
            return {
                ...state,
                hospitalSaveStatus: action.payload.success,
                hospitalUpdateStatus: 0,
            }
        case UPDATEHOSPITAL:
            return {
                ...state,
                hospitalSaveStatus: 0,
                hospitalUpdateStatus: action.payload.success,
            }
        case GETSMS1:

            return {
                ...state,
                smsData1: action.payload.data,
            }
        case UPDATESMS1:
            return {
                ...state,
                sms1UpdateStatus: action.payload.success,
            }

        case GETSMS2:
             return {
                ...state,
                smsData2: action.payload.data,
            }
        case UPDATESMS2:
            return {
                ...state,
                sms2UpdateStatus: action.payload.success,
            }
        case GETSMS3:
             return {
                ...state,
                smsData3: action.payload.data,
           }
        case UPDATESMS3:
            return {
                 ...state,
                sms3UpdateStatus: action.payload.success,
           } 
        case GETSMS4:
             return {
                ...state,
                smsData4: action.payload.data,
           }
        case UPDATESMS4:
            return {
                 ...state,
                sms4UpdateStatus: action.payload.success,
           }  
        case GETSMS5:

           return {
               ...state,
               smsData5: action.payload.data,
           }
       case UPDATESMS5:
           return {
               ...state,
               sms5UpdateStatus: action.payload.success,
           } 
        case GETSMS6:
             return {
                ...state,
                smsData6: action.payload.data,
            }
        case UPDATESMS6:
            return {
                ...state,
                sms6UpdateStatus: action.payload.success,
            }       
        case GETSMS7:
             return {
                ...state,
                smsData7: action.payload.data,
            }
        case UPDATESMS7:
            return {
                ...state,
                sms7UpdateStatus: action.payload.success,
            } 
            case DELETESMS1:
                return {
                    ...state,
                    sms1DeleteStatus: action.payload.success,
                }       
            case DELETESMS2:
                    return {
                        ...state,
                        sms2DeleteStatus: action.payload.success,
                    }     
            
             case DELETESMS3:
                    return {
                        ...state,
                        sms3DeleteStatus: action.payload.success,
                        }       
             case DELETESMS4:
                    return {
                        ...state,
                        sms4DeleteStatus: action.payload.success,
                        }    
            case DELETESMS5:
                    return {
                        ...state,
                        sms5DeleteStatus: action.payload.success,
                        }  
            case DELETESMS6:
                    return {
                        ...state,
                        sms6DeleteStatus: action.payload.success,
                        }     
            case DELETESMS7:
                return {
                        ...state,
                        sms7DeleteStatus: action.payload.success,
                        } 
            case CREATESMS1:
                return {
                ...state,
                 sms1SaveStatus: action.payload.success,
             }           
            case CREATESMS2:
              return {
                ...state,
                 sms2SaveStatus: action.payload.success,
             }
            case CREATESMS3:
              return {
                ...state,
                 sms3SaveStatus: action.payload.success,
             } 
            case CREATESMS4:
              return {
                ...state,
                 sms4SaveStatus: action.payload.success,
             } 
            case CREATESMS5:
               return {
                ...state,
                 sms5SaveStatus: action.payload.success,
             } 
            case CREATESMS6:
                return {
                ...state,
                 sms6SaveStatus: action.payload.success,
             } 
             case CREATESMS7:
                 return {
                  ...state,
                   sms7SaveStatus: action.payload.success,
             }                                                                         
             case CREATEEMAIL:
               return {
                  ...state,
                  emailSaveStatus: action.payload.success,
             }
           case GETEMAIL:
                return {
                ...state,
                 emailList: action.payload.data,
            }
            case UPDATEEMAIL:
                return {
                    ...state,
                    emailUpdateStatus: action.payload.success,
                } 
            case DELETEEMAIL:
                    return {
                             ...state,
                             emailDeleteStatus: action.payload.success,
                            }  
            case CREATEPREFIX:
                    return {
                            ...state,
                            prefixSaveStatus: action.payload.success,
                            } 
            case GETPREFIX:
                    return {
                             ...state,
                            prefixList: action.payload.data,
                         }
            case UPDATEPREFIX:
                    return {
                            ...state,
                            prefixUpdateStatus: action.payload.success,
                            }
            case DELETEPREFIX:
                    return {
                             ...state,
                             prefixDeleteStatus: action.payload.success,
                            } 
            case CREATEROLE:
                    return {
                            ...state,
                             roleSaveStatus: action.payload.success,
                            }
            case GETROLE:
                        return {
                                ...state,
                                roleList: action.payload.data,
                                }
            case UPDATEROLE:
                        return {
                                ...state,
                                roleUpdateStatus: action.payload.success,
                                }
           case DELETEROLE:
                     return {
                         ...state,
                         roleDeleteStatus: action.payload.success,
                            } 
            case CREATELANGUAGE:
                    return {
                            ...state,
                             languageSaveStatus: action.payload.success,
                            } 
            case GETLANGUAGE:
                    return {
                              ...state,
                            languageList: action.payload.data,
                            }
            case UPDATELANGUAGE:
                    return {
                            ...state,
                            languageUpdateStatus: action.payload.success,
                           }
            case DELETELANGUAGE:
                     return {
                            ...state,
                            languageDeleteStatus: action.payload.success,
                            } 
            case CREATECAPTCHA:
                    return {
                            ...state,
                             captchaSaveStatus: action.payload.success,
                            } 
            case GETCAPTCHA:
                    return {
                              ...state,
                            captchaList: action.payload.data,
                            }
            case UPDATECAPTCHA:
                    return {
                            ...state,
                            capatchaUpdateStatus: action.payload.success,
                           }
            case DELETECAPTCHA:
                     return {
                            ...state,
                            captchaDeleteStatus: action.payload.success,
                            } 
            case CREATEMODULE:
                    return {
                            ...state,
                             moduleSaveStatus: action.payload.success,
                            } 
            case GETMODULE:
                    return {
                              ...state,
                            moduleList: action.payload.data,
                            }
            case GETMODULEADMIN:
                    return {
                              ...state,
                            moduleadminList: action.payload.data,
                            }
            case UPDATEMODULE:
                    return {
                            ...state,
                            moduleUpdateStatus: action.payload.success,
                           }
            case DELETEMODULE:
                     return {
                            ...state,
                            moduleDeleteStatus: action.payload.success,
                            }
            case GETALLMODULE:
            return {
                ...state,
                moduleGetData: action.payload.data
                  } 
            case CREATECHILDRENMODULE:
                    return {
                            ...state,
                            childrenmoduleSaveStatus: action.payload.success,
                            } 
            case GETCHILDRENMODULE:
                    return {
                              ...state,
                              childrenmoduleList: action.payload.data,
                            }
            case GETCHILDRENMODULEADMIN:
                    return {
                              ...state,
                              childrenmoduleadminList: action.payload.data,
                            }
            case UPDATECHILDRENMODULE:
                    return {
                            ...state,
                            childrenmoduleUpdateStatus: action.payload.success,
                           }
            case DELETECHILDRENMODULE:
                     return {
                            ...state,
                            childrenmoduleDeleteStatus: action.payload.success,
                            }
            case GETALLCHILDRENMODULE:
            return {
                ...state,
                childrenmoduleGetData: action.payload.data
                  } 
            case CREATEPATIENT:
                    return {
                            ...state,
                             patientSaveStatus: action.payload.success,
                            } 
            case GETPATIENT:
                    return {
                              ...state,
                            patientList: action.payload.data,
                            }
            case UPDATEPATIENT:
                    return {
                            ...state,
                            patientUpdateStatus: action.payload.success,
                           }
            case DELETEPATIENT:
                     return {
                            ...state,
                            patientDeleteStatus: action.payload.success,
                            }
            case CREATESTAFF:
                    return {
                            ...state,
                             staffSaveStatus: action.payload.success,
                            }
            case GETSTAFF:
                    return {
                              ...state,
                            staffList: action.payload.data,
                            }
            case UPDATESTAFF:
                    return {
                            ...state,
                            staffUpdateStatus: action.payload.success,
                           }
            case DELETESTAFF:
                     return {
                            ...state,
                            staffDeleteStatus: action.payload.success,
                            }
         case CREATEBACKUP:
                    return {
                            ...state,
                             backupSaveStatus: action.payload.success,
                            }   
                            
        case GETBACKUP:
                    return {
                            ...state,
                            backupList: action.payload.data,
                            }
        case UPDATEBACKUP:
                    return {
                            ...state,
                            backupUpdateStatus: action.payload.success,
                            }   

        case DELETEBACKUP:
                     return {
                         ...state,
                         backupDeleteStatus: action.payload.success,
                            }  
        case CREATEPAYMENT1:
            return {
                ...state,
                 payment1SaveStatus: action.payload.success,
             }
        case CREATEPAYMENT2:
            return {
                ...state,
                 payment2SaveStatus: action.payload.success,
             }
        case CREATEPAYMENT3:
                return {
                    ...state,
                     payment3SaveStatus: action.payload.success,
                 }  
         case CREATEPAYMENT4:
                    return {
                        ...state,
                         payment4SaveStatus: action.payload.success,
                     } 
        case CREATEPAYMENT5:
                        return {
                            ...state,
                             payment5SaveStatus: action.payload.success,
                         }  
        case CREATEPAYMENT6:
                        return {
                                ...state,
                                 payment6SaveStatus: action.payload.success,
                        }      
         case CREATEPAYMENT7:
                        return {
                                ...state,
                                 payment7SaveStatus: action.payload.success,
                            }                      
        case CREATEPAYMENT8:
                        return {
                                ...state,
                                 payment8SaveStatus: action.payload.success,
                            }     
        case CREATEPAYMENT9:
            return {
                ...state,
                 payment9SaveStatus: action.payload.success,
             } 
     case CREATEPAYMENT10:
                return {
                    ...state,
                     payment10SaveStatus: action.payload.success,
                 }   
     case CREATEPAYMENT11:
            return {
                ...state,
                 payment11SaveStatus: action.payload.success,
             }  
    case CREATEPAYMENT12:
            return {
                ...state,
                 payment12SaveStatus: action.payload.success,
             }  
    case CREATEPAYMENT13:
                return {
                    ...state,
                     payment13SaveStatus: action.payload.success,
                 }  
    case CREATEPAYMENT14:
                    return {
                    ...state,
                     payment14SaveStatus: action.payload.success,
                     }  
    case CREATEPAYMENT15:
                  return {
                ...state,
                 payment15SaveStatus: action.payload.success,
             } 
    case CREATEPAYMENT16:
            return {
                ...state,
                 payment16SaveStatus: action.payload.success,
             }                 
        case GETPAYMENT1:
            return {
                   ...state,
                   paymentData1: action.payload.data,
               }
        case UPDATEPAYMENT1:
                return {
                    ...state,
                    payment1UpdateStatus: action.payload.success,
                }         
        case GETPAYMENT2:
                return {
                       ...state,
                       paymentData2: action.payload.data,
                   }
        case UPDATEPAYMENT2:
                   return {
                       ...state,
                       payment2UpdateStatus: action.payload.success,
                   }              
        case GETPAYMENT3:
                    return {
                           ...state,
                           paymentData3: action.payload.data,
                       }
        case UPDATEPAYMENT3:
                    return {
                           ...state,
                           payment3UpdateStatus: action.payload.success,
                       }    
        case GETPAYMENT4:
                    return {
                           ...state,
                           paymentData4: action.payload.data,
                       }
        case UPDATEPAYMENT4:
                       return {
                           ...state,
                           payment4UpdateStatus: action.payload.success,
                       } 
        case GETPAYMENT5:
                        return {
                               ...state,
                               paymentData5: action.payload.data,
                           }
        case UPDATEPAYMENT5:
                           return {
                               ...state,
                               payment5UpdateStatus: action.payload.success,
                           }               
         case GETPAYMENT6:
                        return {
                                   ...state,
                                   paymentData6: action.payload.data,
                               }
        case UPDATEPAYMENT6:
                         return {
                                   ...state,
                                   payment6UpdateStatus: action.payload.success,
                               } 
        case GETPAYMENT7:
                         return {
                                       ...state,
                                       paymentData7: action.payload.data,
                                }
        case UPDATEPAYMENT7:
                         return {
                                       ...state,
                                     payment7UpdateStatus: action.payload.success,
                                }                                                                          
        case GETPAYMENT8:
                         return {
                                     ...state,
                                     paymentData8: action.payload.data,
                                }
        case UPDATEPAYMENT8:
                         return {
                                     ...state,
                                    payment8UpdateStatus: action.payload.success,
                              }       
        case GETPAYMENT9:
                         return {
                                    ...state,
                                    paymentData9: action.payload.data,
                                }
        case UPDATEPAYMENT9:
                         return {
                                     ...state,
                                    payment9UpdateStatus: action.payload.success,
                                } 
        case GETPAYMENT10:
                        return {
                                     ...state,
                                    paymentData10: action.payload.data,
                               }
        case UPDATEPAYMENT10:
                         return {
                                    ...state,
                                     payment10UpdateStatus: action.payload.success,
                                }
        case GETPAYMENT11:
                        return {
                                ...state,
                                paymentData11: action.payload.data,
                               }
        case UPDATEPAYMENT11:
                        return {
                                 ...state,
                                payment11UpdateStatus: action.payload.success,
                               }
        case GETPAYMENT12:
                        return {
                                ...state,
                                paymentData12: action.payload.data,
                               }                        
        
        case UPDATEPAYMENT12:
                        return {
                                 ...state,
                                 payment12UpdateStatus: action.payload.success,
                               } 
        case GETPAYMENT13:
                        return {
                                 ...state,
                                paymentData13: action.payload.data,
                               }                        
                
        case UPDATEPAYMENT13:
                        return {
                                 ...state,
                                payment13UpdateStatus: action.payload.success,
                               }   
        case GETPAYMENT14:
                        return {
                                ...state,
                                paymentData14: action.payload.data,
                               }                        
                        
        case UPDATEPAYMENT14:
                     return {
                             ...state,
                             payment14UpdateStatus: action.payload.success,
                            }        
        case GETPAYMENT15:
                    return {
                            ...state,
                            paymentData15: action.payload.data,
                            }                        
                                
        case UPDATEPAYMENT15:
                     return {
                            ...state,
                            payment15UpdateStatus: action.payload.success,
                            } 
        case GETPAYMENT16:
                    return {
                            ...state,
                            paymentData16: action.payload.data,
                            }                        
                                
        case UPDATEPAYMENT16:
                    return {
                            ...state,
                             payment16UpdateStatus: action.payload.success,
                           }  
        case DELETEPAYMENT1:
                    return {
                             ...state,
                             payment1DeleteStatus: action.payload.success,
                            }      
        case DELETEPAYMENT2:
                    return {
                            ...state,
                            payment2DeleteStatus: action.payload.success,
                          } 
        case DELETEPAYMENT3:
                    return {
                            ...state,
                            payment3DeleteStatus: action.payload.success,
                           }   
        case DELETEPAYMENT4:
                    return {
                             ...state,
                             payment4DeleteStatus: action.payload.success,
                           }  
                           
        case DELETEPAYMENT5:
                    return {
                             ...state,
                             payment5DeleteStatus: action.payload.success,
                            }  
        case DELETEPAYMENT6:
                    return {
                             ...state,
                             payment6DeleteStatus: action.payload.success,
                            }   
        case DELETEPAYMENT7:
                    return {
                            ...state,
                             payment7DeleteStatus: action.payload.success,
                           } 
      case DELETEPAYMENT8:
                    return {
                             ...state,
                             payment8DeleteStatus: action.payload.success,
                          }   
     case DELETEPAYMENT9:
                    return {
                             ...state,
                             payment9DeleteStatus: action.payload.success,
                          } 
     
    case DELETEPAYMENT10:
                     return {
                            ...state,
                             payment10DeleteStatus: action.payload.success,
                            } 
    case DELETEPAYMENT11:
                     return {
                            ...state,
                            payment11DeleteStatus: action.payload.success,
                            }  
    case DELETEPAYMENT12:
                    return {
                             ...state,
                             payment12DeleteStatus: action.payload.success,
                           } 
    case DELETEPAYMENT13:
                    return {
                             ...state,
                             payment13DeleteStatus: action.payload.success,
                           }  
    case DELETEPAYMENT14:
                    return {
                             ...state,
                             payment14DeleteStatus: action.payload.success,
                           }  
    case DELETEPAYMENT15:
                    return {
                             ...state,
                             payment15DeleteStatus: action.payload.success,
                          }   
    case DELETEPAYMENT16:
                    return {
                             ...state,
                             payment16DeleteStatus: action.payload.success,
                          }                                                 
        default:
              return state
    }
}